import React from 'react';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getCurrentOrganization } from '../utils/organizationContext';

const NewConvertThankYou = () => {
  const navigate = useNavigate();
  const { organizationSlug: urlSlug } = useParams();
  const { organizationSlug } = useAuth();
  
  // Get organization slug from URL or context
  const currentOrgSlug = urlSlug || organizationSlug || getCurrentOrganization();
  
  const handleReturnHome = () => {
    // Always try to go back to the new convert form for the current organization
    if (currentOrgSlug) {
      navigate(`/${currentOrgSlug}/new-convert`, { replace: true });
    } else {
      // Fallback: go to welcome page
      navigate('/', { replace: true });
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 6, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom color="primary">
          Welcome to the Family of God!
        </Typography>
        
        <Typography variant="h6" sx={{ mb: 4 }}>
          Thank you for accepting Jesus Christ as your Lord and Savior.
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          We are excited to be part of your journey of faith. Our team will be in touch with you soon to provide support and guidance.
        </Typography>

        <Typography variant="body1" sx={{ mb: 4 }}>
          "Therefore, if anyone is in Christ, the new creation has come: The old has gone, the new is here!" - 2 Corinthians 5:17
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleReturnHome}
          >
            Submit Another Record
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default NewConvertThankYou; 